<template>
  <authorization permissionKey="configuration_appraisal" can="read">
    <v-container fluid>
      <v-row>
        <v-col class="text-h3 gray--text"> Modelos de laudo </v-col>
      </v-row>

      <v-row>
        <v-col cols="6">
          <v-select
            v-model="examTemplate"
            label="Template de exame"
            outlined
            dense
            hide-details
            :items="examTemplates"
            item-text="name"
            background-color="white"
            return-object
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <AppraisalList v-if="examTemplate" :examTemplate="examTemplate" />
        </v-col>
      </v-row>
    </v-container>
  </authorization>
</template>

<script>
import AppraisalList from "@/components/config/appraisal/list.vue";

export default {
  name: "AppraisalConfig",
  components: {
    AppraisalList,
  },
  data() {
    return {
      examTemplate: null,
    };
  },
  apollo: {
    examTemplates: {
      query: require("@/graphql/exam/exam_templates.gql"),
      update(data) {
        let exams = this.lodash.orderBy(
          data.examTemplates,
          [
            (e) =>
              e.name
                .toLowerCase()
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, ""),
          ],
          ["asc"]
        );
        exams = this.lodash.filter(exams, { visible: true });
        return exams;
      },
      pollInterva: 2000,
    },
  },
};
</script>

<style lang="scss" scoped></style>
